import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  HomePage,
  ModelExplorationPage,
  Tools,
  Learning,
  Contact,
  Legal,
  GoogleAnalytics,
  CookieConsent,
  ScrollToTop,
} from "./shared";
import { Box, CircularProgress } from "@mui/material";
import { WorkingThemeProvider } from "./shared/components/ThemeProvider/WorkingThemeProvider";

// 3D viewers, loaded with their code (three.js, circuit loading) only when
// one of their pages is opened
const CircuitExplorationLayout = lazy(() =>
  import("./modules/microcircuits/components/CircuitExploration").then(
    (module) => ({ default: module.CircuitExplorationLayout }),
  ),
);
const AtlasExplorationLayout = lazy(() =>
  import("./modules/microcircuits/components/AtlasExploration").then(
    (module) => ({ default: module.AtlasExplorationLayout }),
  ),
);
const MorphologyViewer = lazy(() =>
  import("./modules/microcircuits/components/MorphologyViewer").then(
    (module) => ({ default: module.MorphologyViewer }),
  ),
);

const PageLoading: React.FC = () => (
  <Box
    sx={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress />
  </Box>
);

const App: React.FC = () => {
  return (
    <WorkingThemeProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <CookieConsent />
        <GoogleAnalytics />
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/model-exploration" element={<ModelExplorationPage />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/learning" element={<Learning />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/microcircuits" element={<CircuitExplorationLayout />} />
            <Route path="/atlas" element={<AtlasExplorationLayout />} />
            <Route path="/morpho" element={<MorphologyViewer />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </WorkingThemeProvider>
  );
};

export default App;
